import { DSRootCategoryPage } from 'shared-definitions/types'
import RootCategoryTemplate from 'shared-components/templates/RootCategoryTemplate'
import { DSNCAA } from 'types.aa.ds'
import NC from 'nc/NC'
import { getds } from 'ds'
import { useCallback } from 'react'
import { CommonDataContext } from 'shared-components/contexts/CommonDataContext'
import PlaywireTagged from 'shared-components/ad/PlaywireTagged'
import styleUtils from 'shared-components/styles/util.module.css'
import TopBannerInContent from 'shared-components/ad/TopBannerInContent'

interface RootCategoryTemplateAAProps {
  page: DSRootCategoryPage<DSNCAA>
}

const RootCategoryTemplateAA: React.VFC<RootCategoryTemplateAAProps> = ({ page }) => {
  const { ts } = CommonDataContext.useContainer()
  const pageLoader = useCallback(
    async (pageNumber: number, perPage: number) => {
      const dataSource = await getds({ ts })
      const result = await dataSource.getTplPage(page.slug, pageNumber, perPage)
      if (
        !result.data ||
        result.data.resource === 'redirect' ||
        result.data.resource !== 'root-category-page'
      ) {
        return []
      }

      return result.data.latest.posts.items
    },
    [page.slug, ts]
  )

  return (
    <RootCategoryTemplate
      leaderboard={<TopBannerInContent />}
      sideBar={<PlaywireTagged className={styleUtils.sidebarEl} type="med_rect_atf" />}
      page={page}
      nc={NC}
      pageLoader={pageLoader}
    />
  )
}

export default RootCategoryTemplateAA
